<template>
    <BaseTooltipHelp
        :theme="theme"
        :size="size"
        :position="position"
        data-spec-class="tooltip-help-volume"
    >
        {{ bandwidthHint }}
        <BaseLink
            class="mt-1"
            :href="articleUrl"
            target="_blank"
        >
            {{ t('actions.moreInfo') }}
        </BaseLink>
    </BaseTooltipHelp>
</template>

<script setup lang="ts">
import { Size, Theme, TooltipPosition } from '../../../types';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

const { t } = useI18n();

interface Props {
    size?: Size;
    theme?: Theme;
    bandwidthHint?: string | null;
    position?: TooltipPosition;
}

const props = withDefaults(defineProps<Props>(), {
    size: Size.Large,
    theme: Theme.Dark,
    bandwidthHint: null,
    position: TooltipPosition.Right,
});

const bandwidthHint = computed(
    () => props.bandwidthHint ?? t('configuratorGeneral.includedBandwidthHint.default')
);

const articleUrl =
    'https://service.23m.com/hc/articles/7553053939484-What-does-the-95-traffic-calculation-mean';
</script>
